import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from "@angular/common/http";
import { RespuestaAPI } from "src/interface/api-responses.model";
import { environment } from 'src/environments/environment';
import { Observable, Subject } from "rxjs";


const API = "https://admin.api.municipios.saion.mx/";
var token = localStorage.getItem('token');

if (token === null) {
  token = '';
}

const headers = new HttpHeaders({
  'Authorization': 'App' + token!
});
@Injectable({
  providedIn: 'root'
})



export class GeneralService{

  constructor(private http:HttpClient){}

  //---Observable para indicar URL de foto obtenida---
  urlFoto: any;
  private subject = new Subject<any>();
  url: string = API + "/";







  nuevoDoc(form: any) {
    let direccion = this.url + "/municipios/nuevo/doc";
    return this.http.post<RespuestaAPI>(direccion, form,{headers});
  }

  nuevoDocN(form: any) {
    let direccion = this.url + "/municipios/fraccionV/nuevo";
    return this.http.post<RespuestaAPI>(direccion, form);
  }

  nuevoeEnlace(form: any) {
    let direccion = this.url + "/municipios/nuevo/enlace";
    return this.http.post<RespuestaAPI>(direccion, form,{headers});
  }

  verEnlaces() {
    return this.http.get<RespuestaAPI>(API +`/municipios/enlaces`);
  }

  editarDoc(form:any){
    let direccion = this.url + "/municipios/actualizar"
    return this.http.put<RespuestaAPI>(direccion, form,{headers});
}

  obtener(id: any, municipios: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/${id}/${municipios}`);
  }
  obtenerA8(id: any,  inciso: any, municipios: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/${id}/${inciso}/${municipios}`);
  }

  obtenerA152018(id: any, municipios: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A15/2018/${id}/${municipios}`);
  }

  obtenerA152019(id: any, municipios: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A15/2019/${id}/${municipios}`);
  }

  obtenerA152020(id: any, municipios: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A15/2020/${id}/${municipios}`);
  }

  obtenerA152021(id: any, municipios: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A15/2021/${id}/${municipios}`);
  }

  obtenerA152022(id: any, municipios: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A15/2022/${id}/${municipios}`);
  }

  obtenerA82018(id: any, municipios: any, inciso: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/2018/${id}/${inciso}/${municipios}`);
  }

  obtenerA82019(id: any, municipios: any, inciso: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/2019/${id}/${inciso}/${municipios}`);
  }

  obtenerA82020(id: any, municipios: any, inciso: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/2020/${id}/${inciso}/${municipios}`);
  }

  obtenerA82021(id: any, municipios: any, inciso: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/2021/${id}/${inciso}/${municipios}`);
  }

  obtenerA82022(id: any, municipios: any, inciso: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/2022/${id}/${inciso}/${municipios}`);
  }
  obtenerSUBSIDIO(id: any, municipios: any, inciso: any) {
    return this.http.get<RespuestaAPI>(API +`/municipios/docs/A8/${id}/${inciso}/${municipios}`);
  }
  obtenerIdentificadorDocumentos(idEmpresa: any){
    let direccion = API + `/preregistro/obtenerIdentificadorDocumentos/${idEmpresa}`
    return this.http.get<RespuestaAPI>(direccion);
  }
  obtenerIdentificadorDocumentosmunicipios(idEmpresa: any){
    let direccion = API + `/preregistro/obtenerIdentificadorDocumentos/${idEmpresa}`
    return this.http.get<RespuestaAPI>(direccion);
  }
  eliminarEnlace(form: any){
    const direccion = API + "/municipios/actualizar";
    return this.http.put<RespuestaAPI>(direccion, form,{headers});
  }

  eliminarEnlaceN(form: any){
    const direccion = API + "/municipios/actualizar/fraccionV";
    return this.http.put<RespuestaAPI>(direccion, form,{headers});
  }

  limpiarEnlaces(){
    const direccion = API + "/municipios/eliminar";
    return this.http.get<RespuestaAPI>(direccion,{headers});
  }

  actualizarNoticia(form: any){
    const direccion = API + "/municipios/noticia/actualizar";
    return this.http.put<RespuestaAPI>(direccion, form,{headers});
  }

  verNoticias(){
    const direccion = API + "/municipios/noticias";
    return this.http.get<RespuestaAPI>(direccion);
  }
}
